import React from 'react';

import styles from './ContactInfo.module.scss'

const phoneIcon = <i className="far fa-phone text-secondary" />
const emailIcon = <i className="far fa-envelope text-secondary" />

export const ContactInfo = ({
    user,
    title="CONTACT INFO",
    subtitle="",
    icons=true,
    showLabels=true,
    showEmail=true,
    showHomePhone=true,
    showMobilePhone=true,
    maxWidth="250px",
    border=true,
    hover=false,
    alignment="center"
})=>{

    return(
        <div 
            style={{maxWidth: maxWidth}} 
            className={`
                ${styles["contact-info-wrapper"]}
                ${styles[border ? "border" : ""]}   
                ${styles[hover ? "hover" : ""]} 
            `}
        >
            {title &&
                <p className={styles["title"]}>{title}</p>
            }
            {subtitle &&
                <p className={styles["subtitle"]}>{subtitle}</p>
            }
            <div className={`
                ${styles["main-body"]}
                ${alignment === "center" ? styles["center"] : ""}
            `}>
                <div className={styles["main-body"]}>

                    {showEmail && user?.email &&
                        <div>
                            {icons &&
                                <span className={styles["icon"]}>
                                    {emailIcon}
                                </span>
                            }
                            {showLabels &&
                                <span className={styles["label"]}>Email: </span>
                            }
                            {user.email}
                        </div>
                    }
                    {showHomePhone && user?.home_phone &&
                        <div>
                            {icons &&
                                <span className={styles["icon"]}>
                                    {phoneIcon} 
                                </span>
}
                            {showLabels &&
                                <span className={styles["label"]}>Home: </span>
                            }
                            {user.home_phone}
                        </div>   
                    }
                    {showMobilePhone && user?.mobile_phone &&
                        <div>
                            {icons &&
                                <span className={styles["icon"]}>
                                    {phoneIcon} 
                                </span>
                            }
                            {showLabels &&
                                <span className={styles["label"]}>Mobile: </span>
                            }
                            {user.mobile_phone}
                        </div>   
                    }
                </div>
            </div>
        </div>
    )
}